<template>
<div class="tickets-checkin">
  <div class="row">
    <div class="col-xs-12">
      <p-search
        placeholder="Buscar por código do ticket ..."
        @on-search="handleSearch($event)"
        class="input-group input-group-lg"
      />
    </div>
  </div>
  <div
    v-if="ticketId"
    v-loading="loading"
    style="margin-top: 50px;"
  ></div>
  <div v-if="ticket && ticketId">
    <div class="row">
      <div class="col-md-8">
        <customer-card
          :customer="customer"
          v-loading="loadingCustomer"
          v-if="customer"
          :showEditButton="false"
        />
      </div>
      <div
        class="col-md-4"
        v-if="!loadingCustomer"
      >
        <customer-image-card
          :has-image="true"
          :customer="customer"
          :showEditButton="false"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-lg-8">
        <TicketCard
          :ticket="ticket"
          :event="event"
          :stock="stock"
        />
      </div>
      <div class="col-xs-12 col-lg-4">
        <ticket-actions v-loading="!ticket._id"/>
      </div>
      <div class="col-xs-12" v-loading="!ticket._id">
        <DocumentsTicketCard :ticket-id="ticketId"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import GalleryComponent from 'src/components/GalleryComponent'
import CustomerCard from 'src/pages/Customers/CustomerCard.vue'
import CustomerImageCard from 'src/pages/Customers/CustomerImageCard.vue'
import TicketActions from './TicketActions'
import TicketCard from 'src/pages/Tickets/TicketCard'
import { mapActions, mapGetters } from 'vuex'
import DocumentsTicketCard from '../../components/Trg/Tickets/DocumentsTicketCard'

export default {
  name: 'tickets-details',

  components: {
    GalleryComponent,
    CustomerCard,
    CustomerImageCard,
    TicketCard,
    TicketActions,
    DocumentsTicketCard
  },

  computed: {
    ...mapGetters('tickets', ['ticket', 'ticketSearching', 'loading']),
    ...mapGetters('customers', {
      customer: 'customer',
      loadingCustomer: 'loading'
    }),
    ...mapGetters('events', {
      event: 'event'
    }),
    ...mapGetters('stocks', {
      stock: 'stock'
    }),

    imgs: function () {
      const baseUrl = 'http://127.0.0.1:5984/trg_docs/0e72963680950920add238ed65006194/'
      const attachments = [
        'imagem_evento_1562187132613.jpg',
        'imagem_evento_1562187132501.jpg',
        'imagem_evento_1562187132375.jpg'
      ]
      return attachments.map(item => `${baseUrl}${item}`)
    },

    ticketId () {
      return this.$route.params.id
    }
  },

  methods: {
    ...mapActions('customers', { fetchCustomer: 'fetchOne', getUrlImg: 'getUrlImg' }),
    ...mapActions('stocks', { fetchStock: 'fetchOne' }),
    ...mapActions('events', { fetchEvent: 'fetchOne' }),
    ...mapActions('tickets', {
      fetchTicket: 'fetchOne',
      fetchTicketCustomerEvent: 'fetchTicketCustomerEvent',
      resetTicket: 'resetOne',
      getTicketByBarCode: 'fetchViewOne'
    }),

    handleSearch (event) {
      if (this.ticketSearching) {
        this.$notify({
          message: 'Aguarde o termino da busca do cliente.',
          type: 'info'
        })
      } else {
        this.getTicketByBarCode({ ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: event, notCommit: true })
          .then(response => {
            this.fetchTicketCustomerEvent({ ticketId: response._id })
            this.$router.push({ name: 'tickets.details', params: { id: response._id } })
          })
          .catch(err => console.log(err))
      }
    }
  },

  mounted () {
    if (this.ticketId) {
      this.fetchTicket(this.ticketId)
        .then(result => {
          this.getUrlImg({ id: result.customerId })
          this.fetchCustomer(result.customerId)
          this.fetchEvent(result.eventId)
          this.fetchStock(result.stockId)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketsDetails.vue